// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","277":"83f69f3e","389":"5fa6541c","732":"fda73a07","857":"1c392658","977":"01378288"}[chunkId] + ".chunk.js";
};